import PropTypes from 'prop-types'
import React from 'react'

import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'

import UnifiedInput from '../IdentificationTypes/UnifiedInput'

export const IdentificationSelector = ({
  getFocus,
  identificationType,
  onSetCustomerIdentification,
  requestFailed,
  orderForm,
}) => {
  const handleError = (error) => {
    requestFailed({
      error,
      errorTitle: getIntlMessage('errorFallback'),
    })
  }

  const handleSubmit = (value) => {
    logClickEvent(`identify-by-${identificationType}`, 'Sale', {
      customer: value,
    })
    onSetCustomerIdentification(value)
  }
  const getInitialValue = () =>
    orderForm?.clientProfileData?.document
      ? orderForm?.clientProfileData?.document
      : orderForm?.clientProfileData?.email

  return (
    <div className="pa5 pt0-l">
      <div>
        <UnifiedInput
          countryCode={orderForm?.storePreferencesData?.countryCode ?? 'BRA'}
          getFocus={getFocus}
          getInitialValue={getInitialValue}
          onSubmit={handleSubmit}
          onError={handleError}
        />
      </div>
    </div>
  )
}

export default IdentificationSelector

IdentificationSelector.propTypes = {
  getFocus: PropTypes.any,
  identification: PropTypes.object,
  identificationType: PropTypes.string,
  onSetCustomerIdentification: PropTypes.func,
  onChangeIdType: PropTypes.func,
  visible: PropTypes.bool,
  requestFailed: PropTypes.func.isRequired,
}
